import { useListenKey } from "./useListenKey"
import { useOnClickOutside } from "./useOnClickOutside"
import { useWatchFocus } from "./useWatchFocus"

export const useDropdownCloseListeners = <T extends HTMLElement>(
  ref: React.RefObject<T>,
  handleClose: () => void,
) => {
  useOnClickOutside(ref, handleClose)
  useWatchFocus(ref, handleClose)
  useListenKey(ref, handleClose, "Escape", { global: false, listenChild: true })
}
